import React, { useEffect } from 'react';
import { axiosInstance } from "utils";
// import { DEBUG } from 'consts';


const setResponse = response => {
  // if (DEBUG) console.assert('RESPONSE', response);
  //if(!response.data.hasOwnProperty("metadata")) response.data['metadata'] = null;
  //response.data['message'] = response.status + ' ' + response.statusText;
  let message = response.status + `${response.statusText && ' - ' + response.statusText}`;

  if (response.data?.message) return response.data;

  if (typeof response.data === 'object') {
    response.data['message'] = message;
  } else {
    response.data = {
      ...response.data,
      message: response.status + ' ' + response.statusText
    }
  }

  return response.data;
}

const withRequest = (Component) => (props) => {

  const reqInterceptor = (req) => {
    if (window.config?.DEBUG && window.config.DEBUG) console.error('REQUEST', req);
  }

  const resInterceptor = axiosInstance.interceptors.response.use(
		(response) => {
      if (response) {
        if (response?.data) {
          return Promise.resolve(response);
        } else return Promise.resolve(response);
      }
		},
		(error) => {
      if (error) {
        if (error.response?.data) {
          return Promise.reject(setResponse(error.response));
        } else return Promise.reject(error);
      }
		}
	);

  useEffect(() => {
    return () => {
      axiosInstance.interceptors.request.eject(reqInterceptor);
      axiosInstance.interceptors.response.eject(resInterceptor);
    };
  }, [resInterceptor]);

  return (
    <>
      <Component {...props} />
    </>
  )
}

export default withRequest;
